import { render } from "./ExcelConfiguration.vue?vue&type=template&id=37eb36fc&scoped=true&ts=true"
import script from "./ExcelConfiguration.vue?vue&type=script&lang=ts"
export * from "./ExcelConfiguration.vue?vue&type=script&lang=ts"

import "./ExcelConfiguration.vue?vue&type=style&index=0&id=37eb36fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37eb36fc"]])

export default __exports__